module.exports = __webpack_public_path__ + "img/shutterstock_127633466-v1.797c30d5.jpg";